import { CSSProperties } from "react";

import Icon from "../Icon";

import styles from "./customIcon.module.scss";

export const PRICE_SOURCE_TO_ICON: Record<number, CustomIcons> = {
  1: "cardKingdom",
  2: "tcg",
  3: "mtgo",
  4: "cardmarket",
  5: "scg-simple",
  6: "manapool",
  7: "tcgland",
  8: "cardtrader",
};

export type CustomIcons =
  | "scg"
  | "scg-simple"
  | "cardKingdom"
  | "tcg"
  | "cardhorder"
  | "cardmarket"
  | "manapool"
  | "tcgland"
  | "cardtrader"
  | "mtgo"
  | "arena"
  | "edhrec"
  | "archidekt";

type Props = {
  name: CustomIcons;
  className?: string;
  style?: CSSProperties;
};

const CustomIcon = ({ name, className, style }: Props) => {
  return <Icon className={`${name} ${styles.icon} ${className}`} style={style} />;
};

export default CustomIcon;
